<template>
  <div class='box' id='box' ref='ct'>
    <van-button  round type="primary" class='registration' icon='arrow' icon-position='right' @click="isRegisteredShow">立即注册</van-button>
    <div class="title">
      <van-search
        v-model="search"
        shape="round"
        background="#4fc08d"
        placeholder="搜索"
        @search="onSearch"
      />
      <!-- 推荐 -->
      <!-- <ul class="tip">  
        <li class="tip-good" v-for="(item,index) in tip" :key="index" @click="recommend(item)">{{item}}</li>
      </ul> -->
      <ul class='e-sort' >
        <li v-for="item in classifyList.slice(0,14)" :key="item.operatingPositionId" @click='e_sort(item)'>
          <a href="javascript:;"><img class="img-sort" :src="item.showImageUrl"><p class='e_text' :class="{active:active == item.paramValue ? 'active' : ''}">{{item.imageName}}</p></a>
        </li>
      </ul>
    </div>
    <!-- 分类 -->
    <!-- <ul class='sort'>
      <li v-for="item in classifyList.slice(0,14)" :key="item.operatingPositionId" @click="goClassify(item)">
        <a href="javascript:;"><img class="img-sort" :src="item.showImageUrl"><p style="text">{{item.imageName}}</p></a>
      </li>
    </ul> -->
    <!-- 轮播图 -->
    <van-swipe  :autoplay="3000" lazy-render  class="swipe">
      <van-swipe-item v-for="item in swipeList" :key="item.operatingPositionId">
        <img class="img-swipe" :src="item.showImageUrl">
      </van-swipe-item>
    </van-swipe>
    <!-- 商品列表 -->
    <div v-if='Listloading' class="loading">
      <van-loading type="spinner" color="#1989fa"  /> 
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      class="goods"
      v-if='!Listloading'
    >
      <ul class="goods">
        <li v-for="(item,index) in goods" :key="index" class="goods-content" @click="goodsDetail(item)">
          <a href="javascript:;">
            <img class="img-goods" :src="item.picUrl">
            <p>{{item.goodsName}}</p>
            <!-- <p>{{'每'+item.goodsUnitLabel+"("+item.saleRatio+item.goodsUnitLabel+")"}}</p> -->
            <div class="sales">销量:{{item.orderQty | filterOrderQty }}</div>
          </a>
        </li>
      </ul>
    </van-list>
    <van-popup v-model="show">
      <img class="popup_img" src="../../assets/laxin.png">
      <van-button round class="nowRegistered" icon='arrow' icon-position='right' @click="isRegisteredShow">立即注册</van-button>
      <van-icon class="popup_icon" name="cross" @click="popupShow" />
    </van-popup>
    <keep-alive>
    <registered :registeredShow=registeredShow @close="close" @closeSunccess="closeSunccess" :show=show></registered>
    </keep-alive>
  </div>
</template>

<script>
import registered from "../common/registered";
export default {
  components: {
    registered
  },
  data() {
    return {
      show:true,
      loading:false,
      finished: false,
      search: '',
      registeredShow:false,
      tip:['小排','芒果','大米','车厘子','土豆'],
      sort: [
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
        {name: '蔬菜',url: require('../../assets/u=3209370120,2008812818&fm=26&gp=0.jpg')},
      ],
      goods: [],
      swipeList:[],
      classifyList:[],  
      scroll: '',
      paramValue:'01',
      page: {
        current: 1,
        total: 0,
        size: 10,
      },
      flag: '0',
      Listloading: false,
      sortShow:false,
      active:'1',
    } 
  },
  filters: {
    filterOrderQty(val = 0) {
      let text = val.toFixed(0)
      if (text >= 10000) {
        text = text.slice(0, -4) + '万+'
      }
      return text
    }
  },
  created() {
    if (this.getCookie('popped') == ''){
      document.cookie = "popped = yes";
    }else{
      this.show = false;
    }
  },
  mounted() {
    this.getSwipe()
    this.getclassifyList()
    this.getGoodsList()
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    popupShow() {
      this.show = false
    },
    getCookie(Name) {
      var search = Name + "=";
      var returnValue = "";
      if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search);
        if (offset !== -1) {
          offset += search.length;
          var end = document.cookie.indexOf(";", offset);
          if (end == -1){
            end = document.cookie.length;
          }
          returnValue = decodeURIComponent(document.cookie.substring(offset, end));
        }
      }
      return returnValue;
    },
    // 打开注册弹窗
    isRegisteredShow() {
      this.registeredShow = true
    },
    // 关闭注册弹窗
    close() {
      this.registeredShow = false
      this.show = false
    },
    closeSunccess() {
      this.registeredShow = false
      this.show = false
    },
    //获取轮播图
    getSwipe() {
      let params = {
        showType: "1"
      };
      this.$axios
        .post("operation/permit/operationPosition/showAll", params)
        .then(res => {
          this.swipeList = res.data.data || [];
        })
        .catch(() => {});
    },
    // 获取商品列表
    getclassifyList() {
      let params = {
        showType: "2"
      };
      this.$axios
        .post("operation/operationPosition/showAll", params)
        .then(res => {
          this.classifyList = res.data.data || [];
        })
        .catch(() => {});
    },
    // 列表默认展示
    getGoodsList() {
      this.finished = false
      this.page.current = 1
      this.Listloading = true;
      let params = {
        categoryId: this.paramValue
      }
      this.$axios
        .post(`trade/permit/trade/orderQty?current=${1}&size=${10}`,params)
        .then(res => {this.goods = res.data.data.records,this.flag='0',this.Listloading = false})
        .catch(() => {this.Listloading = false});
    },
    onLoad() {
      this.page.current += 1
      let params = {}
      this.flag == '0' ? params = {categoryId: this.paramValue} : params = {param:this.search}
      if (this.finished) {
        return false
      }
      if (this.flag == '0') {
        this.$axios
          .post(`trade/permit/trade/orderQty?current=${this.page.current}&size=${10}`,params)
          .then(res => {
            const { records = [], pages = 0 } = res.data.data
            if(pages <= this.page.current) { this.finished = true}
            this.goods.push(...records)
            this.loading = false;
          })
          .catch(() => {});
      } else {
        this.$axios
          .post(`trade/permit/tradeSearch?current=${this.page.current}&size=${10}`,params)
          .then(res => {
            const { records = [], pages = 0 } = res.data.data
            if(pages <= this.page.current) { this.finished = true}
            this.goods.push(...records)
            this.loading = false;
            })
          .catch(() => {});
      }
    },
    // 搜索
    onSearch(params) {
      this.Listloading = true;
      params = {
        param:this.search
      }
      this.$axios
      .post(`trade/permit/tradeSearch?current=${1}&size=${10}`,params)
      .then(res => {this.goods = res.data.data.records,this.flag='1',this.Listloading = false})
      .catch(() => {});
    },  
    //推荐
    recommend(item) {
      this.search = item
      this.onSearch({param:item})
    },
    // 分类
    goClassify(item) {
      this.paramValue = item.paramValue
      this.getGoodsList()
    },
    e_sort(item) {
      this.paramValue = item.paramValue
      this.active = item.paramValue
      // console.log(this.active)
      this.getGoodsList()
    },
    // 商品详情
    goodsDetail(item) {
      this.$router.push({
        path: "/PublicityDetails",
        query: { 
          goodsId: item.goodsId,
          saleRatio: item.saleRatio
        }
      })
    },
    handleScroll() {
      let wid = document.getElementById("box").getBoundingClientRect().top;
      if(wid < -300) {
        this.sortShow = true
      }
      if(wid > -300) {
        this.sortShow = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true); //监听页面滚动事件
  },
  // beforeRouteEnter(to,from,next) {
  //   if(from.path==='/protocol') {
  //     next((vm) => {
  //       vm.registeredShow = true;
  //     })
  //     console.log(to);
  //     console.log(from);
  //     console.log(next);
  //   }
  //   next()
	// }
}
</script>

<style scoped lang='scss'>
.box {
  position: relative;
  overflow:hidden;
  // height:100%;
}
.registration {
  position: fixed;
  left: 0;
  top: 80%;
  z-index: 99;
  height: 42px;
  padding: 0 12px;
  border-radius: 0 32px 32px 0;
}

.title {
   position:fixed;
   width: 100%;
   z-index: 999;
}
a {
  color: #000;
}
.tip {
  display:flex;
  background-color: #4fc08d;
  color:#f7f8fa;
  padding-bottom: 10px;
  li {
    margin-left: 10px;
  }
}
.sort {
  display: flex;
  flex-direction:column;
  flex-wrap:wrap;
  height:200px;
  width:94%;
  overflow-x: scroll;
  overflow-y: hidden; 
  margin-top: 65px;
  background-color: #fff;
  margin-bottom:10px;
  overflow: hidden;
  margin-left: 10px;
  border-radius:15px;
  // margin-right: 10px;
  li {
    width: 17%;
    height: 50%;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    // padding-bottom: 10px;
    p {
      font-size: 12px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      text-align: center;
      padding-bottom: 5px;
    }
  }
}
.e-sort {
  // display: flex;
  display: -webkit-box;
  // height:90px;
  overflow-x: scroll;
  overflow-y: hidden; 
  width:100%;
  background-color: #4fc08d;
  .active {
  color: #026639
  }
  li {
    width: 13%;
    height: 90%;
    margin-left: 10px;
    p {
      text-align: center;
      font-size: 12px;
      color:#fff;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      padding-bottom: 5px;
    }
  }
}
.img-sort {
  width: 80%;
  // height: 70%;
  border-radius: 50px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #5eac3b;
}
.goods {
  display: flex;
  flex-wrap:wrap;
  width:100%;
  position: relative;
  li {
    width: 47%;
    background-color: #fff;
    margin: 0 0 10px 10px;
    padding-bottom: 10px;
    p {
      padding-left:5px ;
      font-size: 16px;
    }
  }
  margin-right: 10px;
  .goods-content {
    position: relative;
    .sales {
      position: absolute;
      top: 173px;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      color: #02ad52;
      font-size:13px;
      padding:5px 10px;
    }
  }
}
.img-goods {
  width: 100%;
  height:200px;
}
.img-swipe {
  width: 100%;
  height: 160px;
  border-radius:15px;

}
.swipe {
  margin: 0 10px 10px 10px;
  padding-top: 130px;
}
.van-popup {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
// .popup_img {
//   width: 60%;
//   position: absolute;
//   left:50%;
//   top: 45%;
//   transform: translate(-50%, -50%);
//   border-radius: 32px;
// }
.popup_icon {
  // position: absolute;
  // left:50%;
  top: 3%;
  // transform: translate(-50%, -50%);
  font-size: 32px;
  color:#efefefcc;
}

.popup_img {
width: 60%;
// position: absolute;
// left:50%;
// top: 45%;
// transform: translate(-50%, -50%);
border-radius: 32px;
}
.nowRegistered {
  font-weight: 900;
  height: 32px;
  // position: absolute;
  // left:50%;
  top: -2%;
  // transform: translate(-50%, -50%);
  color: #d12524;
  padding: 0px 15px 0px 20px;
  border:none;
  border-radius: 32px;
  background-color: #fbba46;
}

.loading {
  height:100px;
  width:100%;
  position: relative;
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
::-webkit-scrollbar {
/*隐藏滚轮*/
display: none;
}
/deep/ .van-list__finished-text {
  width: 100%;
  text-align: center;
}
/deep/ .van-list__loading {
  width: 100%;
  text-align: center;
}

</style>
